import { render } from "./VerseTest.vue?vue&type=template&id=00b31c04"
import script from "./VerseTest.vue?vue&type=script&lang=js"
export * from "./VerseTest.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__